import { render, staticRenderFns } from "./category_edit.vue?vue&type=template&id=33449516&scoped=true&"
import script from "./category_edit.vue?vue&type=script&lang=js&"
export * from "./category_edit.vue?vue&type=script&lang=js&"
import style0 from "./category_edit.vue?vue&type=style&index=0&id=33449516&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33449516",
  null
  
)

export default component.exports